export const EMAIL_REGEX = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
export const UPPERCASE_REGEX = new RegExp("[A-Z]");
export const LOWERCASE_REGEX = new RegExp("[a-z]");
export const DIGIT_REGEX = new RegExp("[0-9]");
export const STRIPE = Stripe(document.querySelector("meta[name='stripe_public_key']").content);
// export const DOMAIN = document.querySelector("meta[name='domain']").content
